import Product from "constants/ProductConstants";
import {
  aipFeatures,
  bssFeatures,
  cashFlowProtectionFeatures,
  criticarePlusFeatures,
  dhanLabhFeatures,
  easyPensionFeatures,
  foreverPensionFeatures,
  fspFlexiIncomeFeatures,
  fspFlexiIncomeProFeatures,
  fspLargeSumFeatures,
  gcapFeatures,
  gisFeatures,
  gssLumpsumIncomeFeatures,
  pgiLongTermIncomeFeatures,
  pgiLumpsumFeatures,
  pgiRetirementFeatures,
  pgiShortTermIncomeFeatures,
  pgsFeatures,
  posForeverPensionFeatures,
  posGISFeatures,
  posGSSFeatures,
  posSJBFeatures,
  posSaralNiveshFeatures,
  saralPensionFeatures,
  singlePayEndowmentFeatures,
  sjbFeatures,
  wealthPlusFeatures,
  wealthPremierFeatures,
  wealthUltimaFeatures,
  zindagiProtectLCO,
  activePensionPlusFeatures,
  aisFeatures
} from "constants/ProductFeaturesList";

import smartLifeStyleUtils from "modules/optimization/components/products/smart-life-style/utils";
import incomeBuilderUtils from "modules/optimization/components/products/income-builder/utils";
import fetchProductLevelRidersFeature from "./fetchProductLevelRidersFeature";
import ProductNames from "constants/ProductNames";

const fetchProductLevelFeature = (productData) => {
  let biData = {};

  if (Array.isArray(productData.data.BI)) {
    biData = productData.data.BI.find(
      (item) => item.risk === productData.selectedTab
    );
  } else {
    biData = productData.data;
  }

  if (biData?.bi_request?.PR_ID === ProductNames.flexiSavingsPlan) {
    if (biData?.product_name === Product.FLEXI_SAVINGS_PLAN_FLEXI_INCOME) {
      return fetchProductLevelRidersFeature(fspFlexiIncomeFeatures, biData);
    }

    if (biData?.product_name === Product.FLEXI_SAVINGS_PLAN_FLEXI_INCOME_PRO) {
      return fetchProductLevelRidersFeature(fspFlexiIncomeProFeatures, biData);
    }

    if (biData?.product_name === Product.FLEXI_SAVINGS_PLAN_LARGE_SUM_OPTION) {
      return fetchProductLevelRidersFeature(fspLargeSumFeatures, biData);
    }

    return fetchProductLevelRidersFeature([], biData);
  }
  switch (biData?.product_name) {
    case Product.CASH_FLOW_PROTECTION_PLUS:
      return fetchProductLevelRidersFeature(cashFlowProtectionFeatures, biData);

    case Product.GCAP:
      return fetchProductLevelRidersFeature(gcapFeatures, biData);

    case Product.SINGLE_PAY_ENDOWMENT_ASSUARANCE_PLAN:
      return fetchProductLevelRidersFeature(singlePayEndowmentFeatures, biData);

    case Product.FOREVER_PENSION:
    case Product.FOREVER_PENSION_DEFERRED_ANNUITY:
    case Product.FOREVER_PENSION_IMMEDIATE_ANNUITY:
    case Product.POS_FOREVER_PENSION:
      return foreverPensionFeatures;

    case Product.POS_SARAL_NIVESH:
      return posSaralNiveshFeatures;

    case Product.SARAL_JEEVAN_BIMA:
      return sjbFeatures;

    case Product.CRITICARE_PLUS:
      return criticarePlusFeatures;

    case Product.WEALTH_ULTIMA:
    case Product.SYSTEMATIC_WITHDRAWAL_PLAN_WEALTH_ULTIMA:
    case Product.LITTLE_CHAMP_WEALTH_ULTIMA:
      return wealthUltimaFeatures;

    case Product.WEALTH_PLUS:
      return wealthPlusFeatures;

    case Product.DHAN_LABH:
      return fetchProductLevelRidersFeature(dhanLabhFeatures, biData);

    case Product.WEALTH_PREMIER:
      return wealthPremierFeatures;

    case Product.ACTIVE_INCOME_PLAN:
    case Product.ACTIVE_INCOME_PLAN_WITH_FIB:
      return fetchProductLevelRidersFeature(aipFeatures, biData);

    case Product.SARAL_PENSION:
      return saralPensionFeatures;

    case Product.POS_FOREVER_PENSION:
      return posForeverPensionFeatures;

    case Product.POS_SARAL_JEEVAN_BIMA:
      return posSJBFeatures;

    case Product.PREMIER_GUARANTEED_INCOME_LUMPSUM:
      return fetchProductLevelRidersFeature(pgiLumpsumFeatures, biData);

    case Product.PREMIER_GUARANTEED_SHORT_TERM_INCOME:
      return fetchProductLevelRidersFeature(pgiShortTermIncomeFeatures, biData);

    case Product.PREMIER_GUARANTEED_LONG_TERM_INCOME:
      return fetchProductLevelRidersFeature(pgiLongTermIncomeFeatures, biData);

    case Product.PREMIER_GUARANTEED_RETIREMENT_INCOME:
      return fetchProductLevelRidersFeature(pgiRetirementFeatures, biData);

    case Product.GUARANTEED_INCOME_STAR:
      return fetchProductLevelRidersFeature(gisFeatures, biData);

    case Product.GUARANTEED_FLEX_STAR:
      return fetchProductLevelRidersFeature(gisFeatures, biData);

    case Product.ASSURED_INCOME_STAR:
      return fetchProductLevelRidersFeature(aisFeatures, biData);

    case Product.GUARANTEED_SAVINGS_STAR_LUMPSUM:
    case Product.GUARANTEED_SAVINGS_STAR_INCOME:
      return fetchProductLevelRidersFeature(gssLumpsumIncomeFeatures, biData);

    case Product.PREMIER_GUARANTEED_STAR:
      return fetchProductLevelRidersFeature(pgsFeatures, biData);

    case Product.PREMIER_GUARANTEED_STAR_PRO:
      return fetchProductLevelRidersFeature(pgsFeatures, biData);

    case Product.SMART_LIFESTYLE:
    case Product.FAMILY_PROTECTION_OPTION_SMART_LIFESTYLE:
      return smartLifeStyleUtils.fetchSmartLifeStyleFeatures(biData);

    case Product.INCOME_BUILDER:
    case Product.SECURED_INCOME_OPTION_INCOME_BUILDER:
      return incomeBuilderUtils.fetchIncomeBuilderFeatures(biData);

    case Product.ZINDAGI_PROTECT:
      if (Number(biData?.bi_request?.PlanOption) === 130) {
        return fetchProductLevelRidersFeature(zindagiProtectLCO, biData);
      } else {
        return fetchProductLevelRidersFeature([], biData);
      }

    case Product.EASY_PENSION:
      return easyPensionFeatures;

    case Product.POS_GUARANTEED_INCOME_STAR:
      return posGISFeatures;

    case Product.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR:
      return posGISFeatures;

    case Product.POS_GUARANTEED_SAVINGS_STAR:
      return posGSSFeatures;
    case Product.BHARAT_SAVINGS_STAR_INCOME:
    case Product.BHARAT_SAVINGS_STAR_LUMPSUM:
    case Product.POS_BHARAT_SAVINGS_STAR_INCOME:
    case Product.POS_BHARAT_SAVINGS_STAR_LUMPSUM:
      return fetchProductLevelRidersFeature(bssFeatures, biData);

    case Product.ACTIVE_PENSION_PLUS:
      return activePensionPlusFeatures;

    default:
      return [];
  }
};

export default fetchProductLevelFeature;
